import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function HeroSection() {
  const featuredArticles = getFeaturedArticles();
  const mainArticle = featuredArticles[0];
  const sideArticles = featuredArticles.slice(1, 3);

  return (
    <section className="relative w-full pt-16">
      <div className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60 z-10"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20modern%20newsroom%20with%20large%20screens%20displaying%20breaking%20news%20headlines%2C%20dark%20moody%20atmosphere%2C%20red%20accent%20lighting%2C%20high%20contrast%20cinematic%20composition%2C%20professional%20journalism%20environment%2C%20intense%20atmosphere%2C%20urban%20night%20view%20through%20windows%2C%20editorial%20photography%20style%2C%20deep%20shadows%20with%20warm%20highlights&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="黑料社头条焦点背景"
          className="w-full h-full object-cover object-top"
        />

        <div className="absolute inset-0 z-20 flex items-end">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 pb-12 md:pb-16">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {mainArticle && (
                <Link
                  to={`/article/${mainArticle.id}`}
                  className="lg:col-span-2 group cursor-pointer"
                >
                  <div className="flex items-center gap-2 mb-3">
                    <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">
                      {mainArticle.category}
                    </span>
                    <span className="text-background-300/80 text-xs">{mainArticle.publishedAt}</span>
                  </div>
                  <h1 className="text-2xl md:text-4xl font-bold text-background-50 mb-3 leading-tight group-hover:text-primary-300 transition-colors font-heading line-clamp-2">
                    {mainArticle.title}
                  </h1>
                  <p className="text-background-200/80 text-sm md:text-base line-clamp-2 max-w-2xl">
                    {mainArticle.excerpt}
                  </p>
                  <div className="flex items-center gap-4 mt-4 text-xs text-background-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {mainArticle.views.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-message-2-line"></i> {mainArticle.comments.toLocaleString()}
                    </span>
                  </div>
                </Link>
              )}

              <div className="flex flex-col gap-4">
                {sideArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group cursor-pointer bg-background-950/50 backdrop-blur-sm rounded-lg p-4 border border-background-800/30 hover:border-primary-500/50 transition-all"
                  >
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 bg-accent-500 text-background-950 text-xs font-semibold rounded-full whitespace-nowrap">
                        {article.category}
                      </span>
                    </div>
                    <h3 className="text-sm md:text-base font-semibold text-background-100 group-hover:text-primary-300 transition-colors font-heading line-clamp-2">
                      {article.title}
                    </h3>
                    <div className="flex items-center gap-3 mt-2 text-xs text-background-500">
                      <span>{article.publishedAt}</span>
                      <span>{article.views.toLocaleString()} 阅读</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}